module.exports = __webpack_public_path__ + "static/media/Item_Weapon_DP28_C.c4b63507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_DP28_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_DP28_C.png
// module chunks = 0